<rect width="32" height="32" fill="currentColor" rx="16" />
<path
    fill="var(--gw-rd-white-color)"
    d="M24.242 8H7.757c-.27 0-.524.067-.753.176l8.956 8.957 2.008-1.93 7.027-7.027A1.737 1.737 0 0 0 24.242 8ZM25.824 9.001l-6.613 6.613 6.613 6.613c.11-.23.176-.483.176-.753V9.754c0-.27-.066-.523-.176-.753ZM6.175 9.001c-.11.23-.176.483-.176.754v11.719c0 .27.066.524.176.753l6.612-6.613-6.612-6.613Z"
/>
<path
    fill="var(--gw-rd-white-color)"
    d="m18.383 16.447-2.008 1.93a.584.584 0 0 1-.829 0l-1.93-1.93-6.612 6.612c.229.11.482.177.753.177h16.485c.27 0 .524-.067.753-.177l-6.612-6.612Z"
/>
